import * as React from 'react';
import {FormattedMessage, injectIntl} from 'react-intl';
import {VideoContentTypeOptions} from "@models/video-content";
import {VideoContentStatusOptions} from "@models/video-content";
import Search, {SearchInputType} from "@components/custom/Search";
import {SelectionMode} from "@models";


interface SearchInputProps {
  search: (filter: object) => any;
  form: any;
}

const SearchVideosComponent: React.FC<SearchInputProps> = props => {
  const {search} = props;

  const inputs = [{
    name: "query",
    label: <FormattedMessage id="app.title" defaultMessage={`Title`}/>,
    type: SearchInputType.TEXT,
    size: 12
  }, {
    name: "video_content_type",
    label: <FormattedMessage id="app.type" defaultMessage={`Type`}/>,
    type: SearchInputType.SELECT,
    options: VideoContentTypeOptions,
    size: 12
  }, {
    name: "status",
    label: <FormattedMessage id="app.status" defaultMessage={`Status`}/>,
    type: SearchInputType.SELECT,
    options: VideoContentStatusOptions,
    selectionType : SelectionMode.MULTIPLE,
    size: 12
  }, {
    name: "category_ids",
    label: <FormattedMessage id="app.category" defaultMessage={`Category`}/>,
    type: SearchInputType.CATEGORY,
    multiple : true,
    size: 12
  },{
    name: "tag_ids",
    label: <FormattedMessage id="app.tag" defaultMessage={`Tag`}/>,
    type: SearchInputType.TAG,
    multiple : true,
    size: 12
  }];

  return <Search inputs={inputs} search={search}/>

};

export default SearchVideosComponent;